import React, { useMemo, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Button, Form, Input, Label } from "reactstrap"
import Select from "react-select"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import moment from "moment"
import { getMonitorIpsStock } from "store/monitor-dashboard/monitor-dashboard-action"
import { isObject } from "lodash"

const MonitorIPsStockFilter = ({
  onCategoryChange,
  provIpsStockLoading,
  getSearchData,
  onIPsAdvanceSearchHandler,
}) => {
  // get ips
  const ips = useSelector(state => state.monitorDashboard.MonitorIps)
  // get items
  const items = useSelector(state => state.monitorDashboard.MonitorItems)
  // get item categories
  const categories = useSelector(
    state => state.monitorDashboard.MonitorItemCategoires
  )

  // get fund codes
  const fundCodes = useSelector(
    state => state.monitorDashboard.monitorFundCodes
  )

  // get shipments
  const shipments = useSelector(
    state => state.monitorDashboard.monitorShipments
  )

  // filter items based select box need
  const filteredItems = useMemo(
    () =>
      items?.data.map(item => ({
        value: item.id,
        label: `${item.unfp_item_name} ( ${item.item_name} )`,
      })),
    [items]
  )

  const dispatch = useDispatch()

  const fromdateFlatpicker = useRef(null)
  const todateFlatpicker = useRef(null)
  const [Ips, setIps] = useState(null)
  const [category, setCategory] = useState(null)
  const [item, setItem] = useState(null)
  const [batchNumber, setBatchNumber] = useState("")
  const [fundCode, setFundCode] = useState(null)
  const [waybillNumber, setWaybillNumber] = useState("")
  const [shipment, setShipment] = useState(null)
  const [receiptType, setReceiptType] = useState(null)
  const [distributionType, setDistributionType] = useState(null)
  const [fromDate, setFromDate] = useState(null)
  const [toDate, setToDate] = useState(null)

  // Store filtered data and dispatch the action using onAdvancedSearchHandler callback function
  const handleSubmit = () => {
    let searchs = {}
    searchs.ips = Ips ? Ips.value : null
    searchs.category = category ? category.value : null
    if (item) {
      searchs.item = item.map(ite => (ite.value ? ite.value : ite))
    }
    searchs.batchNumber = batchNumber
    searchs.fundCode = isObject(fundCode) ? fundCode.value : null
    searchs.waybillNumber = waybillNumber
    searchs.shipment = isObject(shipment) ? shipment.value : null
    if (receiptType) {
      searchs.receiptType = receiptType.map(rt => (rt.value ? rt.value : rt))
    }
    if (distributionType) {
      searchs.distributionType = distributionType.map(dt => (dt.value ? dt.value : dt))
    }
    searchs.from = fromDate
    searchs.to = toDate
    getSearchData({ Ips, category, item, batchNumber, fundCode, waybillNumber, shipment, receiptType, distributionType, fromDate, toDate })
    onIPsAdvanceSearchHandler(searchs)
  }

  // store IP value
  const IpsChangeHandler = ip => {
    setIps(ip)
  }

  // store Category value
  const onCategoryChangeHandler = category => {
    onCategoryChange(category.value)
    setCategory(category)
  }

  // store multiple Item values based we selected
  const onItemChangeHandler = item => {
    const check = item.some(ite => ite.value === "all")
    if (check) {
      setItem(filteredItems)
    } else {
      setItem(item)
    }
  }
  // clear search when clear button clicked
  const onClearHandler = () => {
    fromdateFlatpicker.current.flatpickr.clear()
    todateFlatpicker.current.flatpickr.clear()
    setIps(null)
    setCategory(null)
    setItem(null)
    setBatchNumber("")
    setFundCode(null)
    setWaybillNumber("")
    setShipment(null)
    setReceiptType(null)
    setDistributionType(null)
    setFromDate(null)
    setToDate(null)
    getSearchData({})
    onIPsAdvanceSearchHandler({})
    dispatch(getMonitorIpsStock())
  }

  return (
    <Form
      onSubmit={e => {
        e.preventDefault()
        handleSubmit()
        return false
      }}
    >
      <div className="mb-3">
        <Label className="form-label">IPs</Label>
        {ips?.data && (
          <Select
            options={[{ value: "all", label: "All" }, ...ips?.data]}
            value={Ips}
            onChange={IpsChangeHandler}
          />
        )}
      </div>

      <div className="mb-3">
        <Label className="form-label">Item Categories</Label>
        {categories?.data && (
          <Select
            placeholder="All Categories"
            options={[{ value: "all", label: "All" }, ...categories?.data]}
            value={category}
            onChange={onCategoryChangeHandler}
          />
        )}
      </div>

      {filteredItems && (
        <div className="mb-3">
          <Label className="form-label">Items</Label>
          <Select
            isMulti={true}
            options={[{ value: "all", label: "All" }, ...filteredItems]}
            value={item}
            onChange={onItemChangeHandler}
          />
        </div>
      )}
      <div className="mb-3">
        <Label className="form-label">Batch Number</Label>
        <Input
          name="name"
          value={batchNumber}
          onChange={value => {
            setBatchNumber(value.target.value)
          }}
          placeholder="Name"
          type="text"
        />
      </div>

      <div className="mb-3">
        <Label className="form-label">Fund Code</Label>
        {fundCodes?.data && (
          <Select
            placeholder="All Fund Codes"
            options={[{ value: "all", label: "All" }, ...fundCodes?.data]}
            value={fundCode}
            onChange={setFundCode}
          />
        )}
      </div>

      <div className="mb-3">
        <Label className="form-label">Waybill Number</Label>
        <Input
          name="waybillNumber"
          value={waybillNumber}
          onChange={value => {
            setWaybillNumber(value.target.value)
          }}
          placeholder="Waybill Number"
          type="text"
        />
      </div>

      <div className="mb-3">
        <Label className="form-label">Shipment</Label>
        {shipments?.data && (
          <Select
            placeholder="All Shipments"
            options={[{ value: "all", label: "All" }, ...shipments?.data]}
            value={shipment}
            onChange={setShipment}
          />
        )}
      </div>

      <div className="mb-3">
        <Label className="form-label">Receipt Types</Label>
        <Select
          isMulti={true}
          placeholder="All Receipt Types"
          options={[
            { value: "all", label: "All" },
            { value: "Receipts", label: "Receipts" },
            { value: "Other Source", label: "Other Source" },
            { value: "Opening Balance", label: "Opening Balance" },
          ]}
          value={receiptType}
          onChange={setReceiptType}
        />
      </div>

      <div className="mb-3">
        <Label className="form-label">Distribution Types</Label>
        <Select
          isMulti={true}
          placeholder="All Distribution Types"
          options={[
            { value: "all", label: "All" },
            { value: "Distribution", label: "Distribution" },
            { value: "Exchange", label: "Exchange" },
            { value: "Transfer", label: "Transfer" },
          ]}
          value={distributionType}
          onChange={setDistributionType}
        />
      </div>

      <div className="mb-3 ">
        <Label className="form-label">From Date</Label>
        <Flatpickr
          ref={fromdateFlatpicker}
          className="form-control d-block"
          placeholder="dd M,yyyy"
          options={{
            altInput: true,
            altFormat: "Y-m-d",
            dateFormat: "Y-m-d",
          }}
          onChange={value => {
            setFromDate(moment(value[0]).format("YYYY-MM-DD"))
          }}
        />
        <br />
        <Label className="form-label">To Date</Label>
        <Flatpickr
          ref={todateFlatpicker}
          className="form-control d-block"
          placeholder="dd M,yyyy"
          options={{
            altInput: true,
            altFormat: "Y-m-d",
            dateFormat: "Y-m-d",
          }}
          onChange={value => {
            setToDate(moment(value[0]).format("YYYY-MM-DD"))
          }}
        />
      </div>

      <div className="d-flex flex-wrap gap-2">
        <Button
          type="submit"
          className="btn btn-sm btn-primary"
          color="primary"
          disabled={provIpsStockLoading}
        >
          {provIpsStockLoading ? "Please Wait..." : "Search"}
        </Button>
        <Button
          onClick={onClearHandler}
          className="btn btn-sm btn-danger"
          color="primary"
        >
          Clear
        </Button>
      </div>
    </Form>
  )
}

export default MonitorIPsStockFilter
